import React, { useState, useContext, useEffect, useRef } from 'react';
import { StyledAmenitiesModalFilterDiv } from './index.styles';
// import { AmenitiesFiltersComponentsProps } from './../../index.types';
import { renderedData } from '../../organisms/searchResults';
import { SearchFilterContext } from '../../index.context';
import { SearchFacetsConstants, SearchFacetsList, SearchFacetsListCodes } from '../../index.constant';
import { eventUtil } from '@marriott/mi-ui-library-shop';
import { Modal } from '@marriott/mi-ui-library';
import { AmenitiesFilterComponent } from '.';
import { getSearchAppliedFilter, SearchActions } from '../../../store/store.action';
import { SearchStateExtendsType, SearchStateFilterObj, SearchFacetsResponse } from '../../../store/store.type';
import { useSessionUpdateContext } from '../../../../../../context/SessionUpdateContext';
import { updateQueryParams } from '../../../lib/helper';
import { usePageContext } from '../../../../../../context/PageContext';
import { Button } from '@marriott/mi-ui-library';
import { useCheckBreakpoint } from '@marriott/mi-ui-library';

declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface HTMLAttributes<T> {
    custom_click_track_value?: string;
  }
}

export const AmenitiesModalComponent: React.FC<{
  filterData?: Array<SearchFacetsResponse>;
  setFetchCurrencyConversionFactors: React.Dispatch<React.SetStateAction<boolean>>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tooltipRefElement?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setTooltipContent?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  modalRefElement?: any;
}> = ({ filterData, setFetchCurrencyConversionFactors, tooltipRefElement, setTooltipContent, modalRefElement }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { jsonContent, setFeatureSelected, isMapViewEnabled }: any = useContext(renderedData);
  const { searchQueryState, setSearchQuery } = useContext(SearchFilterContext);
  const { interactionsSelected, setInteractionsSelected } = useSessionUpdateContext();
  const { headersData } = usePageContext();
  const [popupOpenState, setPopupOpenState] = useState(false);
  const clickTrackingLoc = 'Phoenix Search Results';
  const [filterSelectionData, setFilterSelectionData] = useState<SearchStateExtendsType>();
  const [currFilterData, setCurrFilterData] = useState<Array<SearchFacetsResponse> | undefined>(filterData);
  const amenities = searchQueryState?.filter?.filter(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (key: any) => key.type.code === SearchFacetsListCodes.amenities
  )[0];
  const isActive =
    searchQueryState[SearchFacetsList.amenities] &&
    Object.keys(searchQueryState[SearchFacetsList.amenities] ?? {}).length;

  const bodyRef = useRef<HTMLBodyElement | null>(null);
  const isDesktop = useCheckBreakpoint('viewportM'); // check if viewport is desktop till 768px

  useEffect(() => {
    bodyRef.current = document.body as HTMLBodyElement;
  }, []);

  const onFilterChange = (type: SearchFacetsList, data: SearchStateFilterObj): void => {
    let arr1: SearchStateExtendsType = { ...filterSelectionData };
    if (filterSelectionData) {
      arr1[type] = data;
    } else {
      arr1 = {
        [type]: data,
      };
    }
    setFilterSelectionData(arr1);
    setInteractionsSelected({ ...interactionsSelected, amenities: true });
    setFetchCurrencyConversionFactors(true);
    eventUtil.dispatch('updateShopPageFilterModalValues', { ...searchQueryState, ...arr1 });
  };

  const applyBtnHandler = (): void => {
    const payload = filterSelectionData === undefined ? { [SearchFacetsList.amenities]: {} } : filterSelectionData;
    // Update the selected amenities filter values in the URL
    const amenities = Object.values(payload?.[SearchFacetsList.amenities] as SearchStateFilterObj);

    updateQueryParams(
      {
        amenities,
      },
      ['amenities'],
      headersData?.referer
    );

    setSearchQuery({
      type: SearchActions.updateOtherSearchQueryParam,
      payload: {
        [SearchFacetsConstants.offset]: 0,
      },
    });
    setSearchQuery({ type: SearchActions.setApplyFilter, payload: payload });
    setSearchQuery({
      type: SearchActions.setQuery,
      payload: {
        [SearchFacetsConstants.facets]: {
          ...getSearchAppliedFilter(payload, searchQueryState),
        },
        [SearchFacetsConstants.options]: {
          ...searchQueryState.search[SearchFacetsConstants.options],
          [SearchFacetsConstants.includeTaxes]: searchQueryState[SearchFacetsConstants.includeTaxes],
          [SearchFacetsConstants.unavailableProperties]: searchQueryState[SearchFacetsConstants.unavailableProperties],
        },
      },
    });
  };

  useEffect(() => {
    setCurrFilterData(filterData);
  }, [filterData]);

  useEffect(() => {
    if (!popupOpenState && !isMapViewEnabled && bodyRef.current) {
      bodyRef.current.style.overflow = 'auto';
    }
  }, [popupOpenState]);

  return amenities?.buckets?.length ? (
    <StyledAmenitiesModalFilterDiv>
      <Button
        callback={(): void => {
          setCurrFilterData(undefined);
          if (!isMapViewEnabled && bodyRef.current) {
            bodyRef.current.style.overflow = 'hidden';
          }
          setPopupOpenState(!popupOpenState);
          setFilterSelectionData(searchQueryState[SearchFacetsList.amenities]);
        }}
        className={`m-button-primary-inverse t-label-alt-m button-secondary filter-option-button custom_click_track sm-search-result-all-filter-component-button ${
          isActive ? 'active' : ''
        }`}
        buttonCopy={amenities?.type.label ?? 'Amenities'}
        custom_click_track_value={`${clickTrackingLoc}| Filter Selection: Amenities |internal`}
      ></Button>

      {/* TODO - remove old markup after unit testing on environment */}
      {/* <button
        type="button"
        onClick={(): void => {
          setPopupOpenState(!popupOpenState);
          setFilterSelectionData(searchQueryState[SearchFacetsList.amenities]);
        }}
        className={
          't-label-alt-m filter-option-button custom_click_track sm-search-result-all-filter-component-button ' +
          (isActive ? 'active' : '')
        }
        {...{ custom_click_track_value: `${clickTrackingLoc}| Filter Selection: Amenities |internal` }}
      >
      {amenities?.type.label}*/}
      {/* <span className={`icon-dropdown-${popupOpenState?'up':'down'}`} /> */}
      {/*</button> */}
      {popupOpenState && (
        <Modal
          className={`custom-scrollbar  ${popupOpenState ? '' : 'close-popup-header'}`}
          show={true}
          handleBlur={true}
          popupOpenState={popupOpenState}
          setPopupOpenState={setPopupOpenState}
          allFilterPopUp={true}
          onClose={(): void => {
            setCurrFilterData(undefined);
          }}
          role="dialog"
          labelledBy="ModalPopup"
          modalId="ModalPopup"
        >
          <Modal.Header
            // labelIcon=""
            labelText={jsonContent?.amenitiesLabel}
            // cancelLabel=""
            popupHeaderOnCLoseFunc={setPopupOpenState}
            customHeadingClass={isDesktop ? 't-subtitle-xl' : 't-subtitle-l'}
          >
            <div className="filter-by-title">{jsonContent?.amenitiesLabel}</div>
          </Modal.Header>
          <Modal.Body className="custom-scrollbar" refElement={modalRefElement}>
            <AmenitiesFilterComponent
              clearFilterState={filterSelectionData}
              onItemSelect={onFilterChange}
              allFilterPopUp={false}
              itemList={currFilterData?.filter(key => key.type.code === SearchFacetsListCodes.amenities)[0]}
              tooltipRefElement={tooltipRefElement}
              setTooltipContent={setTooltipContent}
              modalRefElement={modalRefElement}
            />
          </Modal.Body>
          <Modal.Footer
            clearClickHandler={(): void => {
              setCurrFilterData(undefined);
              setFilterSelectionData(undefined);
            }}
            applyBtnClickHandler={applyBtnHandler}
            popupHeaderOnCLoseFunc={setPopupOpenState}
            clearButtonLabel={jsonContent.clearLabel}
            applyLabel={jsonContent.applyLabel}
            setFeatureSelected={setFeatureSelected}
            clickTrackingLoc={clickTrackingLoc}
            className={'pop-up-footer'}
          />
        </Modal>
      )}
    </StyledAmenitiesModalFilterDiv>
  ) : null;
};
